export default __webpack_public_path__ + "static/media/btn-zeroback-stop-de_de@3x.b7924f9c.png";